import React, { useEffect, useState } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";
import { OPDarkContainer, OPBox, OPWrapper } from "../settings/SettingsStyled";
import currencies from "../../helpers/getCurrency";

import {
  TabBox,
  Tab,
  Header,
  Row,
  Exit,
  Item,
  Title,
  OuterBox,
} from "./HistoryStyled";

export default ({
  handleAbove,
  history,
  floorFigure,
  aboveAnim,
  handleAboveAnimation,
  handleNotification,
  getBetReply,
  userId,
  handleRoundID,
  audio,
  userInfo,
}) => {
  const [active, setActive] = useState("my");
  const [closeBtn, setcloseBtn] = useState(false);
  const [soundPlayed, setSoundPlayed] = useState(false);
  const { tabChange, goForward, goBack } = audio;
  const { precision } = userInfo;

  const History = {
    all: history.allHistory,
    my: history.myHistory,
    high: history.highRoller,
  };
  const { my, all, high } = History;
  const [tab, setTab] = useState(my);

  const handleActiveTab = (e) => {
    setActive(e);
  };
  useEffect(() => {
    if (active === "high") {
      setTab(high);
    } else if (active === "my") {
      setTab(my);
    } else {
      setTab(all);
    }
  }, [active, all, my, high]);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };
  const clickHandler = (r, u) => {
    if (userId === u) {
      getBetReply(r);
      handleRoundID(r);
      goForward();
      setSoundPlayed(true);
      handleAbove("betReply");
      handleAboveAnimation(true);
    } else {
      setSoundPlayed(false);
      handleNotification("You can only see your bet reply");
    }
  };
  return (
    <OPDarkContainer aboveAnim={aboveAnim} soundPlayed={soundPlayed}>
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim}>
          <TabBox>
            <OuterBox active={active === "my"}>
              <Tab
                onClick={() => {
                  active !== "my" && tabChange();
                  handleActiveTab("my");
                }}
                active={active === "my"}
              />
              <p>My</p>
            </OuterBox>
            <OuterBox active={active === "all"}>
              <Tab
                onClick={() => {
                  active !== "all" && tabChange();
                  handleActiveTab("all");
                }}
                active={active === "all"}
              />
              <p>All</p>
            </OuterBox>
            <OuterBox active={active === "high"}>
              <Tab
                onClick={() => {
                  active !== "high" && tabChange();
                  handleActiveTab("high");
                }}
                active={active === "high"}
              />
              <p>High</p>
            </OuterBox>
            <Exit
              close={closeBtn}
              aboveAnim={aboveAnim}
              soundPlayed={soundPlayed}
              onClick={() => {
                goBack();
                setAnimation(closeBtn, setcloseBtn);
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnimation(false);
                  setTimeout(() => {
                    handleAbove(false);
                  }, 400);
                }, 150);
              }}
            >
              <CloseSVG />
            </Exit>
          </TabBox>
          <Header precision={precision}>
            <Title>User</Title>
            <Title>Payout</Title>
            <Title>Win Amount</Title>
          </Header>
          <div>
            {tab.map((item, index) => (
              <Row
                soundPlayed={soundPlayed}
                key={index}
                precision={precision}
                cur={userId === item.user_id}
                onClick={() => clickHandler(item.round_id, item.user_id)}
              >
                <Item>{item.user_name}</Item>
                <Item>{floorFigure(item.winCoef, 2)}X</Item>
                <Item
                  win={item.winAmount > 0}
                  className="profit"
                >
                  <p className="winAmount">{item.winAmount}</p>
                  <p style={{ marginLeft: '2px' }}>
                    {currencies[item.currency]}
                    {item.winAmount - item.betAmount > 0 ? "↑" : "↓"}
                  </p>
                </Item>
              </Row>
            ))}
          </div>
        </OPBox>
      </OPWrapper>
    </OPDarkContainer>
  );
};
